import Splide from "@splidejs/splide";

export function initHeaderMessagesSlider()
{
    let elements = document.querySelectorAll('.header-messages-slider');
    elements.forEach(function(element) {
        let splide = new Splide(element, {
            type: 'fade',
            rewind: true,
            arrows: false,
            pagination: false,
            drag: false,
            autoplay: true,
            speed: 1000
        });

        splide.mount();
    });
}